/**
 * @extends com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKMemberConnectedMessageHandler = function() {
	this.constructor.__super__.call(this);
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ChatroomMemberConnectedMessageHandler,com.inq.flash.client.control.messagehandlers.CMSDKMemberConnectedMessageHandler,"com.inq.flash.client.control.messagehandlers.CMSDKMemberConnectedMessageHandler")

com.inq.flash.client.control.messagehandlers.CMSDKMemberConnectedMessageHandler.prototype.processMessage = function (message) {
	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHATROOM_MEMBER_TYPE) == com.inq.flash.client.data.MessageFields.DATA_CHATROOM_MEMBER_AGENT) {
		com.inq.flash.client.control.PersistenceManager.SetValue("va", null, true, true);
		this.controller.getChat().setAutomatonId(null);
	}

	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_OWNER) == com.inq.flash.client.data.MessageFields.DATA_TRUE) {
		// For the VA scenarios the flag connection accepted still can be in false.
		this.getController().setConnectionAccepted(true);
		this.setAgent(
			message.getProperty(com.inq.flash.client.data.MessageFields.KEY_CHATROOM_MEMBER_ID),
			message
		);
	}

	/** @type {string} */
	var isReassignMode = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_IS_REASSIGNMENT_MODE);
	/** @type {string} */
	var tcMode = message.getProperty(com.inq.flash.client.data.MessageFields.KEY_TC_MODE);
	if (tcMode == com.inq.flash.client.data.MessageFields.DATA_TRANSFER
		|| tcMode == com.inq.flash.client.data.MessageFields.DATA_CONFERENCE && message.getProperty(com.inq.flash.client.data.MessageFields.KEY_SCREENING) == com.inq.flash.client.data.MessageFields.DATA_FALSE
		|| isReassignMode == com.inq.flash.client.data.MessageFields.DATA_TRUE
	) { } else {
	    // when agent lost due to network and reconnected to chat room
	    message.addProperty(com.inq.flash.client.data.MessageFields.KEY_TC_MODE, "reconnected");
    }
    this.getController().onNewChatRouterMessage(message);

};
